module.exports = __webpack_public_path__ + "img/icon_sm_wzlysq.20fd1fd3.png";